export const OrderStatus = {
  // 待付款
  unpay: "TO_BE_PAID",
  // 待生效
  effectPending: "TO_BE_EFFECTIVE",
  // 生效中
  guaranteeing: "BECAME_EFFECTIVE",
  // 已终止
  expired: "EXPIRED",
  // 退款中
  refunding: "REFUNDING",
  // 已退款
  refund: "REFUND",
  // 退款失败
  refundFail: "REFUND_FAIL",
  // 承保失败
  insuranceFail: "SUCCESS_SINGLE_FAILED",
  // 已关闭
  closed: "CLOSED",
};
